// `Symbol.split` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.split
require('../internals/define-well-known-symbol')('split');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/es.symbol.split.js
// module id = 292
// module chunks = 1